export const YOGA_POSES = [
  {
    id: 'montagne',
    name: 'La Montagne',
    sanskrit: 'Tadasana',
    level: 'Débutant',
    duration: '30s - 1 min',
    image: 'https://images.unsplash.com/photo-1767611128116-aaee990e7ecb?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1767611128116-aaee990e7ecb?w=600&q=70',
      'https://images.unsplash.com/photo-1767611127093-8ed12ce7789d?w=600&q=70'
    ],
    benefits: [
      "Améliore la posture et l'alignement du corps",
      "Renforce les cuisses, genoux et chevilles",
      "Réduit le stress et calme l'esprit",
      "Développe la conscience corporelle"
    ],
    instructions: [
      "Tenez-vous debout, pieds joints ou écartés à la largeur des hanches.",
      "Répartissez votre poids uniformément sur les deux pieds.",
      "Engagez légèrement les cuisses et rentrez le nombril vers la colonne.",
      "Allongez la colonne vertébrale vers le ciel, épaules détendues.",
      "Bras le long du corps, paumes vers l'avant, doigts actifs.",
      "Regardez droit devant, menton parallèle au sol.",
      "Respirez profondément et maintenez 30 secondes à 1 minute."
    ]
  },
  {
    id: 'arbre',
    name: "L'Arbre",
    sanskrit: 'Vrksasana',
    level: 'Débutant',
    duration: '30s par côté',
    image: 'https://images.unsplash.com/photo-1767611134649-bdb6414af816?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1767611134649-bdb6414af816?w=600&q=70',
      'https://images.unsplash.com/photo-1566645561604-f4fbc67a4d21?w=600&q=70',
      'https://images.unsplash.com/photo-1554067559-269708c83fb6?w=600&q=70'
    ],
    benefits: [
      "Améliore l'équilibre et la concentration",
      "Renforce les chevilles et les mollets",
      "Ouvre les hanches en douceur",
      "Développe la stabilité mentale"
    ],
    instructions: [
      "Commencez en posture de la Montagne.",
      "Transférez le poids sur le pied gauche.",
      "Placez la plante du pied droit sur l'intérieur de la cuisse gauche (jamais sur le genou).",
      "Pressez le pied contre la cuisse et la cuisse contre le pied.",
      "Joignez les mains devant le cœur ou levez les bras au ciel.",
      "Fixez un point immobile devant vous pour l'équilibre.",
      "Maintenez 30 secondes puis changez de côté."
    ]
  },
  {
    id: 'guerrier1',
    name: 'Le Guerrier I',
    sanskrit: 'Virabhadrasana I',
    level: 'Débutant',
    duration: '30s par côté',
    image: 'https://images.unsplash.com/photo-1607909599990-e2c4778e546b?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1607909599990-e2c4778e546b?w=600&q=70',
      'https://images.unsplash.com/photo-1608857846810-ef2632cd75bd?w=600&q=70',
      'https://images.unsplash.com/photo-1697274598105-a5a184da619b?w=600&q=70'
    ],
    benefits: [
      "Renforce les jambes, les bras et le dos",
      "Étire les hanches et la poitrine",
      "Développe l'endurance et la force mentale",
      "Améliore la circulation sanguine"
    ],
    instructions: [
      "Depuis la Montagne, faites un grand pas en arrière avec le pied droit.",
      "Tournez le pied arrière à 45 degrés, talon ancré au sol.",
      "Pliez le genou avant à 90 degrés, aligné au-dessus de la cheville.",
      "Levez les bras au ciel, paumes face à face.",
      "Orientez les hanches vers l'avant.",
      "Allongez la colonne et regardez vers vos mains.",
      "Maintenez 30 secondes puis changez de côté."
    ]
  },
  {
    id: 'guerrier2',
    name: 'Le Guerrier II',
    sanskrit: 'Virabhadrasana II',
    level: 'Débutant',
    duration: '30s par côté',
    image: 'https://images.unsplash.com/photo-1767611131739-a009e323f62f?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1767611131739-a009e323f62f?w=600&q=70',
      'https://images.unsplash.com/photo-1765873205154-a80487d51bd7?w=600&q=70',
      'https://images.unsplash.com/photo-1758599878236-47f6a918aed2?w=600&q=70',
      'https://images.unsplash.com/photo-1561577732-12fffa81b37e?w=600&q=70',
      'https://images.unsplash.com/photo-1758274536471-912e9d20d4fc?w=600&q=70'
    ],
    benefits: [
      "Renforce les jambes et ouvre les hanches",
      "Améliore l'endurance musculaire",
      "Stimule les organes abdominaux",
      "Développe la concentration et la détermination"
    ],
    instructions: [
      "Écartez les pieds d'environ 1 mètre.",
      "Tournez le pied droit à 90 degrés, le gauche légèrement vers l'intérieur.",
      "Pliez le genou droit à 90 degrés au-dessus de la cheville.",
      "Étendez les bras parallèles au sol, paumes vers le bas.",
      "Ouvrez les hanches vers le côté.",
      "Regardez par-dessus les doigts de la main droite.",
      "Maintenez 30 secondes en respirant profondément, puis changez de côté."
    ]
  },
  {
    id: 'cobra',
    name: 'Le Cobra',
    sanskrit: 'Bhujangasana',
    level: 'Débutant',
    duration: '15-30s',
    image: 'https://images.unsplash.com/photo-1720788073783-671ef3c496b3?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1720788073783-671ef3c496b3?w=600&q=70',
      'https://images.unsplash.com/photo-1734873476398-987eabfaaa0e?w=600&q=70',
      'https://images.unsplash.com/photo-1720788074673-aea85ed666cd?w=600&q=70'
    ],
    benefits: [
      "Ouvre la poitrine et les épaules",
      "Renforce la colonne vertébrale",
      "Stimule les organes abdominaux et la digestion",
      "Soulage le stress et la fatigue"
    ],
    instructions: [
      "Allongez-vous sur le ventre, jambes tendues, pieds joints.",
      "Placez les mains sous les épaules, coudes près du corps.",
      "En inspirant, décollez lentement la poitrine du sol.",
      "Utilisez la force du dos, pas seulement les bras.",
      "Gardez les coudes légèrement pliés, épaules loin des oreilles.",
      "Regardez légèrement vers le haut sans comprimer la nuque.",
      "Maintenez 15 à 30 secondes puis redescendez en expirant."
    ]
  },
  {
    id: 'chien-tete-bas',
    name: 'Le Chien Tête en Bas',
    sanskrit: 'Adho Mukha Svanasana',
    level: 'Débutant',
    duration: '1-3 min',
    image: 'https://images.unsplash.com/photo-1557897467-d59fb33eb834?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1557897467-d59fb33eb834?w=600&q=70',
      'https://images.unsplash.com/photo-1632167759227-80bdfe5bfbf2?w=600&q=70'
    ],
    benefits: [
      "Étire tout le dos, les ischio-jambiers et les mollets",
      "Renforce les bras et les épaules",
      "Calme le cerveau et soulage le stress",
      "Énergise tout le corps"
    ],
    instructions: [
      "Mettez-vous à quatre pattes, mains écartées largeur d'épaules.",
      "Crochetez les orteils et poussez les hanches vers le ciel.",
      "Formez un V inversé avec votre corps.",
      "Pressez les mains fermement dans le sol, doigts écartés.",
      "Laissez la tête pendre naturellement entre les bras.",
      "Tendez les jambes progressivement (les talons n'ont pas besoin de toucher le sol).",
      "Respirez profondément et maintenez 1 à 3 minutes."
    ]
  },
  {
    id: 'enfant',
    name: "La Posture de l'Enfant",
    sanskrit: 'Balasana',
    level: 'Débutant',
    duration: '1-5 min',
    image: 'https://images.unsplash.com/photo-1767611102585-baf80e9be291?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1767611102585-baf80e9be291?w=600&q=70',
      'https://images.unsplash.com/photo-1701826510604-933d4f755d35?w=600&q=70'
    ],
    benefits: [
      "Relâche les tensions du dos et des épaules",
      "Calme profondément le système nerveux",
      "Étire doucement les hanches et les cuisses",
      "Position de repos idéale entre les postures"
    ],
    instructions: [
      "À genoux, asseyez-vous sur vos talons.",
      "Écartez les genoux à la largeur des hanches ou plus.",
      "Penchez-vous vers l'avant et posez le front au sol.",
      "Allongez les bras devant vous, paumes au sol.",
      "Ou placez les bras le long du corps, paumes vers le ciel.",
      "Relâchez complètement le poids de votre corps.",
      "Respirez profondément et restez aussi longtemps que souhaité."
    ]
  },
  {
    id: 'triangle',
    name: 'Le Triangle',
    sanskrit: 'Trikonasana',
    level: 'Intermédiaire',
    duration: '30s par côté',
    image: 'https://images.unsplash.com/photo-1597079997686-87eeebe516d8?w=600&q=70',
    gallery: [
      'https://images.unsplash.com/photo-1597079997686-87eeebe516d8?w=600&q=70',
      'https://images.unsplash.com/photo-1584962243363-1822e9e9d1d4?w=600&q=70',
      'https://images.unsplash.com/photo-1767611123603-b5287672949c?w=600&q=70'
    ],
    benefits: [
      "Étire les flancs, les jambes et la colonne vertébrale",
      "Améliore la digestion",
      "Réduit l'anxiété et le stress",
      "Renforce les genoux et les chevilles"
    ],
    instructions: [
      "Écartez les pieds d'environ 1 mètre.",
      "Tournez le pied droit à 90 degrés, le gauche légèrement vers l'intérieur.",
      "Tendez les bras parallèles au sol.",
      "Inclinez le buste vers la droite en gardant les deux flancs allongés.",
      "Posez la main droite sur le tibia, la cheville ou le sol.",
      "Levez le bras gauche vers le ciel, regard vers la main haute.",
      "Maintenez 30 secondes puis changez de côté."
    ]
  }
];
